import { AxiosInstance } from "axios";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { SearchParams } from "../../../types/search-params";
import { MasterArtworkNameState } from "../../../states/meta-artwork/artwork-name/data.type";
import { PageableDTO } from "../../../types/pageable";
import useAxios from "../../../utils/useAxios";
import { useEffect, useState } from "react";

type ArtworkNameResponse =
  | PageableDTO<MasterArtworkNameState[]>
  | MasterArtworkNameState[];

export const fetchArtworkName = async ({
  search,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {

  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
      context:[44]
    });

    const response = await axios.get(
      `/artwork-master/request/?${searchParams.toString()}`,
    )

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useMetaArtworkNameAndNumberRequests({ search }: SearchParams, isSaveOrSubmitInProgress?:any) {
  const axios = useAxios();
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchArtworkName({
        search,
        axios,
      });

      const availableArtworks:any[] = []
      response.forEach((artwork:any) => availableArtworks.push(artwork))

      setData(availableArtworks);
      setIsLoading(false);
    };

    getData();
  }, [search, isSaveOrSubmitInProgress]);

  return { data, isLoading };
}
